var e={exports:{}};export{e as __module};
//# sourceMappingURL=ua-parser.min.js.map
